import React, { useState, useEffect } from 'react'
import InputField from '../CommonComponents/InputMUI'
import PiePage from '../CommonComponents/PiePage.component'
import SelectField from '../CommonComponents/SelectMUI';
import Loader from '../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../presentationals/Popup/Popup.component';
import { saveUpdateAMuScorecard } from './Actioncreator';

const typeData = [
    { name: 'Text', code: 'TEXT' },
    { name: 'Numeric', code: 'NUMERIC' },
    { name: 'Dealer', code: 'DEALER' },
    { name: 'OEM', code: 'OEM' },
]
export default function AddCategory({ Detaildata }) {
    const [loader, setLoader] = useState(false)
    const [popupState, setpopupState] = useState({ show: false, popupStatus: "" })
    const [objectData, setObjectData] = useState({
        creditParam: '',
        type: ''
    })

    useEffect(() => {
        if (Detaildata?.id && Detaildata?.creditParamId) {
            setObjectData({
                creditParam: Detaildata?.creditParam ?? '',
                type: Detaildata?.type ?? ''
            })
        } else {
            setObjectData({
                creditParam: '',
                type: ''
            })
        }
    }, [Detaildata])


    const inputChange = (e, type) => {
        const changeObj = Object.assign({}, objectData);
        changeObj[type] = e
        setObjectData(changeObj)
    }

    const saveHandler = () => {
        setLoader(true)
        saveUpdateAMuScorecard(objectData, (callback) => {
            console.log(callback)
            setLoader(false)
            if (callback?.message == "success") {
                setpopupState({ show: true, popupStatus: "Category Saved Successfully" })
            } else {
                setpopupState({ show: true, popupStatus: "Error Saving Category" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setpopupState({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => { closePopup() }, 5000)
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popupState.show ? <Popup popupStatus={popupState?.popupStatus} closePopup={closePopup} /> : ''
            }

            <div className="communitySection" style={{ marginTop: '50px' }}>
                <div className='container hoverNone card'>
                    <PiePage
                        totalPage={1}
                        currentPage={1}
                        heading={'Add BRE Configurations'}
                    />

                    <div className="row" style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Category Name"
                                variant="outlined"
                                value={objectData?.creditParam}
                                name="creditParam"
                                id="creditParam"
                                type="text"
                                onChange={e => inputChange(e, "creditParam")}
                                size="small"
                            // required={true}
                            />

                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <SelectField
                                value={objectData.type}
                                label="Category Type"
                                onChange={e => inputChange(e, 'type')}
                                name="type"
                                id="type"
                                data={typeData}
                                size={'small'}

                            />

                        </div>
                    </div>
                    <div className='mb-3 mt-2 row' style={{ margin: '20px 0 15px 0' }}>

                        <div className="col-12 text-center">

                            <button className="cred-btn" disabled={(objectData?.creditParam == "" ?? objectData?.creditParam == undefined ?? objectData?.creditParam == null) && (objectData?.type == "" ?? objectData?.type == undefined ?? objectData?.type == null) ? true : false} style={{ fontSize: '16px' }} onClick={e => saveHandler(e)}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
